import { connect } from 'react-redux';
import type { FormOwnProps } from 'shared/connect/connect';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import { type TradeWay as TradeWayModel } from 'state/secondaryMarket/secondaryMarket.model';
import type { AppState } from 'state/state.model';

import { TradeWay } from './TradeWay';

type TradeWayStateProps = {
  tradeWay: Nullable<TradeWayModel>;
};

type TradeWayOwnProps = FormOwnProps;

export type TradeWayProps = TradeWayOwnProps & TradeWayStateProps;

const mapStateToProps = (state: AppState, { formId }: TradeWayOwnProps): TradeWayStateProps => {
  return {
    tradeWay: liveSelectors.getFormTradeWay(state, formId)!,
  };
};

export const connectTradeWay = connect(mapStateToProps);

export const ConnectedTradeWay = connectTradeWay(TradeWay);
